module.exports = __webpack_public_path__ + "img/consultancy-overview-3.1931a2c7.svg";